import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { QuickLoanService } from "../../_QuickLoan/services/quickLoan.service";
import { LmsService } from "../../_Lms/services/lms.service";
import { MasterService } from "../../Shared/app.Masters.Service";
declare var $: any;
import { ActivatedRoute, Params, Router } from "@angular/router";
import * as moment from "moment";
import { LosService } from "src/app/_LOS/services/los.service";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";

@Component({
  selector: 'app-mst-process-employee',
  templateUrl: './mst-process-employee.component.html',
  styleUrls: ['./mst-process-employee.component.scss']
})
export class MstProcessEmployeeComponent implements OnInit {
  showSpinner: boolean = false;
  currentUser: any;
  ProcessList: any[] = [];
  ProcessIds: any = 0;
  ProcessDropdown: any = [];
  DataSource: any;
  displayedColumns: string[] = [
    "ProcessId",
    "Employee_Name",
   
  ];
  DataSourceDetail: any;
  displayedColumnsDetails: string[];


  constructor(private dataSharingService: DataSharingService,
      private snackBar: MatSnackBar,
      private route: ActivatedRoute,
      private lmsService: LmsService,
      private _QuickLoanService: QuickLoanService,
      private _MasterService: MasterService,
      private losService: LosService,
      private _Route: Router,
      private _EncrDecrService: EncrDecrService) {
    
   }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.QuickLoan_ProcessMaster();
  }

  QuickLoan_ProcessMaster(){
    this._QuickLoanService.QuickLoan_ProcessMaster().subscribe((res: any) => {
      this.ProcessDropdown = res;
    });
  }
   OnSearchProcessEmployee() {
      this.showSpinner = true;
      this._QuickLoanService.Process_AssignedEmployees({
       
        ProcessId: this.ProcessIds,
        
      }).subscribe((res: any) => {
        console.log("Result123 : ", res);
        
  
        this.DataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));
        //this.DataSource.paginator = this.paginator;
        //this.DataSource.sort = this.sort;
        this.showSpinner = false;
      });
    }

}
